<template>
  <div>
    <b-modal
      ref="modalDiversityInputs"
      id="modalDiversityInputs"
      size="lg"
      centered
      :hide-header="true"
      :hide-footer="true"
      @hidden="onHidden"
    >
      <div class="py-5 px-2 px-lg-4">
        <h4 class="text-color-1 mb-4">
          Saiba porque é importante pra gente reconhecer suas qualidades e
          características que te tornam uma pessoa única!
        </h4>

        <button
          type="button"
          class="ml-auto close"
          @click="$refs['modalDiversityInputs'].hide()"
        >
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <p>
          Na parceria entre Rendimento e 99jobs valorizamos os caminhos por onde suas aptidões, gostos
          e paixões passaram – passam e passarão, inclusive! E estamos sempre
          buscando formas de potencializar aquilo que te faz único.
        </p>

        <p>
          Por isso, nessa etapa de cadastro, tomamos o cuidado de construir e
          incluir, em parceria com áreas internas e especialistas, questões para
          traduzir e aprofundar ainda mais as características únicas de cada
          pessoa candidata. É importante ressaltar que nenhum desses dados serão
          utilizados como critério de eliminação em processos seletivos – pelo
          contrário, o banco de informações é utilizado para impulsionar ações
          que permitam espaços cada vez mais inclusivos no mercado de trabalho.
        </p>

        <p>
          Nossa intenção como consultoria é respaldar e alavancar, junto a
          empresas de grande influência, ações afirmativas estratégias para
          Recrutamento e Seleção, permitindo que realizem análises de
          diversidade e reduzam vieses nos processos seletivos. Queremos que o
          seu melhor chegue às empresas na hora de preencher uma oportunidade.
        </p>

        <p>
          Não se preocupe, todos os seus dados e auto declaração estarão salvos
          em ambientes seguros em nossa plataforma e em tratamento conforme os
          itens determinados na Lei Geral de Proteção de Dados.
        </p>

        <p>
          Seguimos trabalhando para que fazer o que ama seja uma realidade para
          todas as pessoas.
        </p>

        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-color-1"
            @click="$refs['modalDiversityInputs'].hide()"
          >
            Ok
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close.vue";
export default {
  name: "modalDiversityInputs",

  data() {
    return {
      afterCloseBackTo: "",
    };
  },

  mounted() {
    this.$EventBus.$on("showModalDiversityInputs", (afterCloseBackTo) => {
      this.$refs["modalDiversityInputs"].show();
      this.afterCloseBackTo = afterCloseBackTo;
    });
  },

  destroyed() {
    this.$EventBus.$off("showModalDiversityInputs");
  },

  components: {
    CloseIcon,
  },

  methods: {
    onHidden(e) {
      if (this.afterCloseBackTo && (this.$route.name == "meu-perfil" || this.$route.name == "deixe-seu-perfil")) {
        this.$EventBus.$emit(`show-${this.afterCloseBackTo}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>